  <template >
   <div class="formPosition" v-role="'func'">
     <template>
           <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col>

              <h4 style="text-align:center;"> <span>Pesquisar estudantes Finalistas nas Instituições</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">
       <v-col class="d-flex" cols="3" sm="2">

        <v-select
          v-model="instituicaoSelected"
          :items="instituicoes"
          item-value="idInstituicao"
          item-text="descricao"
          :rules="ruleRequired"
           label="Selecione a instituição"
        ></v-select>

      </v-col>
      <v-col class="d-flex" cols="4" sm="2">
         <v-select
          v-model="anolectivoSelected"
          :items="anolectivos"
          item-value="descricao"
          item-text="descricao"
          :disabled="instituicaoSelected === null"
          @change="PesquisarEstudantes()"
          @click="PesquisarEstudantes()"
          label="Selecione o anolectivo"
        ></v-select>
      </v-col>
        <v-col class="d-flex" cols="4" sm="2">

          <v-progress-circular
            v-if="progresso"
            indeterminate
            color="green"
          ></v-progress-circular>

           <v-select
             v-if="!progresso"
             :items="cursos"
             item-text="descricao"
             item-value="idCurso"
             v-model="cursoSelected"
             :rules="ruleRequired"
             @change="FiltraCurso()"
             @click="FiltraCurso()"
             :disabled="!progresso && !estudantes.length"
            label="Filtrar por Curso"
        ></v-select>

      </v-col>
      <v-col class="d-flex" cols="3" sm="3">
         <label style="color:red" v-if="( instituicaoSelected !== null && anolectivoSelected !== null && !estudantes.length && progresso === false)">Não existe dado neste ano</label>
      </v-col >
       <v-col class="d-flex" cols="3" sm="3">
         <span>Número total de estudantes : {{estudantes_filtro.length}}</span>
       </v-col >
    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
      <v-text-field
              style="width:10px;"
              v-model="searchInDb"
              append-icon="search"
              label="Pesquisa"

              single-line
              hide-details
          ></v-text-field>
    </v-list-item>

<v-row>
  <v-col md="12">
    <v-data-table
            :headers="headers"
            :items="estudantes_filtro"
            :search="searchInDb"
          >
        <template v-slot:item.action="{ item }">
          <v-icon color="green darken-3" size="25" class="mr-2" @click="VerHistoricoAcadmico(item)">receipt</v-icon>
       </template>
      </v-data-table>

  </v-col>
</v-row>
  </v-card>

  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    select2: null,
    select1: null,
    pesquisa_parameto: null,
    cursoSelected: null,
    cursos: [],
    anolectivos: [],
    instituicoes: [],
    estudantes: [],
    estudantes_filtro: [],
    disabilita_ano: true,
    funcionarios: [],
    searchInDb: '',
    anolectivoSelected: null,
    instituicaoSelected: null,
    idMatricula: null,
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Classe', value: 'classe' },
      { text: 'Turma', value: 'turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' },
      { text: 'Actions', value: 'action', sortable: false }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
    this.initializeAnolectivo()
    this.initializeCurso()
    this.$store.state.fromPesquisaFinalista = false
  },
  methods: {

    async initialize () {
      try {
        this.isLoading = true
        this.instituicoes = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.isLoading = false
      }
    },

    async initializeAnolectivo () {
      try {
        this.anolectivos = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async FiltraCurso () {
      this.estudantes_filtro = this.estudantes.filter(c => c.idCurso === this.cursoSelected)
    },

    async initializeCurso () {
      try {
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    VerHistoricoAcadmico (item) {
      this.$store.state.objaluno = item
      this.$store.state.fromPesquisaFinalista = true
      this.$router.push('/estudante/historico-academico')
    },

    async  PesquisarEstudantes () {
      this.progresso = true
      try {
        this.estudantes = await axios
          .get('/estudanteFindAll-finalista/' + this.anolectivoSelected + '/' + this.instituicaoSelected)
          .then(res => res.data)
        this.isLoading = false
        this.progresso = false
        this.estudantes_filtro = this.estudantes
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.progresso = false
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.progresso = false
      }
    }

  }

}

</script>
